const kannada = {
  name: "Kannada",
  native_name: "ಕನ್ನಡ",
  code: "ka",
}

const ka = {
  translation: {
    report_bug: "ದೋಷವನ್ನು ವರದಿ ಮಾಡಿ",
    import: "ಆಮದು",
    file: "ಫೈಲ್",
    new: "ಹೊಸ",
    new_window: "ಹೊಸ ಕಿಟಕಿ",
    open: "ತೆರೆಯಿರಿ",
    save: "ಉಳಿಸಿ",
    save_as: "ಇದಾಗಿ ಉಳಿಸಿ",
    save_as_template: "ಟೆಂಪ್ಲೇಟಾಗಿ ಉಳಿಸಿ",
    template_saved: "ಟೆಂಪ್ಲೇಟ್ ಉಳಿಸಲಾಗಿದೆ!",
    rename: "ಮರುಹೆಸರಿಸಿ",
    delete_diagram: "ಚಿತ್ರವನ್ನು ಅಳಿಸಿ",
    are_you_sure_delete_diagram:
      "ನೀವು ಈ ಚಿತ್ರವನ್ನು ಅಳಿಸಲು ಖಚಿತವಾಗಿ ಬಯಸುತ್ತೀರಾ? ಈ ಕಾರ್ಯಾಚರಣೆ ಬದಲಾಯಿಸಲಾಗದು.",
    oops_smth_went_wrong: "ಅಯ್ಯೋ! ಏನೋ ತಪ್ಪಾಗಿದೆ.",
    import_diagram: "ಚಿತ್ರವನ್ನು ಆಮದು ಮಾಡಿ",
    import_from_source: "SQL ನಿಂದ ಆಮದು ಮಾಡಿ",
    export_as: "ಇದಾಗಿ ರಫ್ತು ಮಾಡಿ",
    export_source: "SQL ರಫ್ತು ಮಾಡಿ",
    models: "ಮಾದರಿಗಳು",
    exit: "ನಿರ್ಗಮಿಸಿ",
    edit: "ತಿದ್ದು",
    undo: "ರದ್ದುಮಾಡಿ",
    redo: "ಮತ್ತೆ ಮಾಡಿ",
    clear: "ಸ್ಪಷ್ಟ",
    are_you_sure_clear:
      "ನೀವು ಚಿತ್ರವನ್ನು ಸ್ಪಷ್ಟಗೊಳಿಸಲು ಖಚಿತವಾಗಿ ಬಯಸುತ್ತೀರಾ? ಇದು ಬದಲಾಯಿಸಲಾಗದು.",
    cut: "ಕತ್ತರಿಸಿ",
    copy: "ನಕಲಿಸಿ",
    paste: "ಅಂಟಿಸಿ",
    duplicate: "ನಕಲು",
    delete: "ಅಳಿಸಿ",
    copy_as_image: "ಚಿತ್ರವಾಗಿ ನಕಲಿಸಿ",
    view: "ನೋಟ",
    header: "ಮೆನುಬಾರ್",
    sidebar: "ಪಾರ್ಶ್ವಪಟ್ಟಿ",
    issues: "ಸಮಸ್ಯೆಗಳು",
    presentation_mode: "ಪ್ರಸ್ತುತೀಕರಣ ಮೋಡ್",
    strict_mode: "ಕಠಿಣ ಮೋಡ್",
    field_details: "ಕ್ಷೇತ್ರದ ವಿವರಗಳು",
    reset_view: "ನೋಟವನ್ನು ಮರುಹೊಂದಿಸಿ",
    show_grid: "ಗ್ರಿಡ್ ತೋರಿಸಿ",
    show_cardinality: "ಕಾರ್ಡಿನಾಲಿಟಿ ತೋರಿಸಿ",
    theme: "ಥೀಮ್",
    light: "ಬೆಳಕು",
    dark: "ಕತ್ತಲೆ",
    zoom_in: "ಜೂಮ್ ಇನ್",
    zoom_out: "ಜೂಮ್ ಔಟ್",
    fullscreen: "ಪೂರ್ಣ ಪರದೆ",
    settings: "ಸೆಟ್ಟಿಂಗ್ಗಳು",
    show_timeline: "ಟೈಮ್‌ಲೈನ್ ತೋರಿಸಿ",
    autosave: "ಸ್ವಯಂ ಉಳಿಸಿ",
    panning: "ಪ್ಯಾನಿಂಗ್",
    show_debug_coordinates: "ಡಿಬಗ್ ಸಂಯೋಜನೆಗಳನ್ನು ತೋರಿಸಿ",
    transform: "ಪರಿವರ್ತನೆ",
    viewbox: "ವೀಕ್ಷಣಾ ಪೆಟ್ಟಿಗೆ",
    cursor_coordinates: "ಕರ್ಸರ್ ಸಂಯೋಜನೆಗಳು",
    coordinate_space: "ಅಂತರ",
    coordinate_space_screen: "ಪರದೆ",
    coordinate_space_diagram: "ಚಿತ್ರ",
    table_width: "ಕೋಷ್ಟಕದ ಅಗಲ",
    language: "ಭಾಷೆ",
    flush_storage: "ಸಂಗ್ರಹವನ್ನು ಫ್ಲಷ್ ಮಾಡಿ",
    are_you_sure_flush_storage:
      "ನೀವು ಸಂಗ್ರಹವನ್ನು ಫ್ಲಷ್ ಮಾಡಲು ಖಚಿತವಾಗಿ ಬಯಸುತ್ತೀರಾ? ಇದು ನಿಮ್ಮ ಎಲ್ಲಾ ಚಿತ್ರಗಳು ಮತ್ತು ಕಸ್ಟಮ್ ಟೆಂಪ್ಲೇಟ್ಗಳನ್ನು ಬದಲಾಯಿಸಲಾಗದಂತೆ ಅಳಿಸುತ್ತದೆ.",
    storage_flushed: "ಸಂಗ್ರಹವನ್ನು ಫ್ಲಷ್ ಮಾಡಲಾಗಿದೆ",
    help: "ಸಹಾಯ",
    shortcuts: "ಶಾರ್ಟ್‌ಕಟ್‌ಗಳು",
    ask_on_discord: "ಡಿಸ್ಕಾರ್ಡ್‌ನಲ್ಲಿ ಕೇಳಿ",
    feedback: "ಪ್ರತಿಕ್ರಿಯೆ",
    no_changes: "ಯಾವುದೇ ಬದಲಾವಣೆಗಳಿಲ್ಲ",
    loading: "ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
    last_saved: "ಕೊನೆಯದಾಗಿ ಉಳಿಸಲಾಗಿದೆ",
    saving: "ಉಳಿಸುತ್ತಿದೆ...",
    failed_to_save: "ಉಳಿಸಲು ವಿಫಲವಾಗಿದೆ",
    fit_window_reset: "ಕಿಟಕಿಗೆ ಹೊಂದಿಸಿ / ಮರುಹೊಂದಿಸಿ",
    zoom: "ಜೂಮ್",
    add_table: "ಕೋಷ್ಟಕವನ್ನು ಸೇರಿಸಿ",
    add_area: "ಪ್ರದೇಶವನ್ನು ಸೇರಿಸಿ",
    add_note: "ಟಿಪ್ಪಣಿಯನ್ನು ಸೇರಿಸಿ",
    add_type: "ಪ್ರಕಾರವನ್ನು ಸೇರಿಸಿ",
    to_do: "ಮಾಡಲು",
    tables: "ಕೋಷ್ಟಕಗಳು",
    relationships: "ಸಂಬಂಧಗಳು",
    subject_areas: "ವಿಷಯ ಪ್ರದೇಶಗಳು",
    notes: "ಟಿಪ್ಪಣಿಗಳು",
    types: "ಪ್ರಕಾರಗಳು",
    search: "ಹುಡುಕಿ...",
    no_tables: "ಯಾವುದೇ ಕೋಷ್ಟಕಗಳಿಲ್ಲ",
    no_tables_text: "ನಿಮ್ಮ ಚಿತ್ರವನ್ನು ನಿರ್ಮಿಸಲು ಪ್ರಾರಂಭಿಸಿ!",
    no_relationships: "ಯಾವುದೇ ಸಂಬಂಧಗಳಿಲ್ಲ",
    no_relationships_text: "ಕ್ಷೇತ್ರಗಳನ್ನು ಸಂಪರ್ಕಿಸಲು ಎಳೆಯಿರಿ ಮತ್ತು ಸಂಬಂಧಗಳನ್ನು ರೂಪಿಸಿ!",
    no_subject_areas: "ಯಾವುದೇ ವಿಷಯ ಪ್ರದೇಶಗಳಿಲ್ಲ",
    no_subject_areas_text: "ಕೋಷ್ಟಕಗಳನ್ನು ಗುಂಪು ಮಾಡಲು ವಿಷಯ ಪ್ರದೇಶಗಳನ್ನು ಸೇರಿಸಿ!",
    no_notes: "ಯಾವುದೇ ಟಿಪ್ಪಣಿಗಳಿಲ್ಲ",
    no_notes_text: "ಹೆಚ್ಚಿನ ಮಾಹಿತಿಯನ್ನು ದಾಖಲಿಸಲು ಟಿಪ್ಪಣಿಗಳನ್ನು ಬಳಸಿ",
    no_types: "ಯಾವುದೇ ಪ್ರಕಾರಗಳಿಲ್ಲ",
    no_types_text: "ನಿಮ್ಮ ಸ್ವಂತ ಕಸ್ಟಮ್ ಡೇಟಾ ಪ್ರಕಾರಗಳನ್ನು ಮಾಡಿ",
    no_issues: "ಯಾವುದೇ ಸಮಸ್ಯೆಗಳು ಪತ್ತೆಯಾಗಿಲ್ಲ.",
    strict_mode_is_on_no_issues:
      "ಕಠಿಣ ಮೋಡ್ ಆಫ್ ಆಗಿದೆ ಆದ್ದರಿಂದ ಯಾವುದೇ ಸಮಸ್ಯೆಗಳು ತೋರಿಸಲಾಗುವುದಿಲ್ಲ.",
    name: "ಹೆಸರು",
    type: "ಪ್ರಕಾರ",
    null: "ಶೂನ್ಯ",
    not_null: "ಶೂನ್ಯವಲ್ಲ",
    primary: "ಪ್ರಾಥಮಿಕ",
    unique: "ಅದ್ವಿತೀಯ",
    autoincrement: "ಸ್ವಯಂವೃದ್ಧಿ",
    default_value: "ಪೂರ್ವನಿಯೋಜಿತ",
    check: "ಪರಿಶೀಲನೆ",
    this_will_appear_as_is: "*ಇದು ತಯಾರಿಸಲಾದ ಸ್ಕ್ರಿಪ್ಟ್‌ನಲ್ಲಿ ಹಾಗೆಯೇ ಕಾಣಿಸುತ್ತದೆ.",
    comment: "ಟಿಪ್ಪಣಿ",
    add_field: "ಕ್ಷೇತ್ರವನ್ನು ಸೇರಿಸಿ",
    values: "ಮೌಲ್ಯಗಳು",
    size: "ಗಾತ್ರ",
    precision: "ನಿಖರತೆ",
    set_precision: "ನಿಖರತೆ ಹೊಂದಿಸಿ: 'ಗಾತ್ರ, ಅಂಕೆಗಳು'",
    use_for_batch_input: "ಬ್ಯಾಚ್ ಇನ್‌ಪುಟ್‌ಗಾಗಿ , ಬಳಸಿ",
    indices: "ಸೂಚಿಗಳು",
    add_index: "ಸೂಚಿಯನ್ನು ಸೇರಿಸಿ",
    select_fields: "ಕ್ಷೇತ್ರಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    title: "ಶೀರ್ಷಿಕೆ",
    not_set: "ಹೊಂದಿಸಲಾಗಿಲ್ಲ",
    foreign: "ವಿದೇಶಿ",
    cardinality: "ಕಾರ್ಡಿನಾಲಿಟಿ",
    on_update: "ನವೀಕರಣದ ಮೇಲೆ",
    on_delete: "ಅಳಿಸುವಾಗ",
    swap: "ಬದಲಾಯಿಸಿ",
    one_to_one: "ಒಂದು ಒಂದು",
    one_to_many: "ಒಂದು ಅನೇಕ",
    many_to_one: "ಅನೇಕ ಒಂದು",
    content: "ವಿಷಯ",
    types_info:
      "ಈ ವೈಶಿಷ್ಟ್ಯವು PostgreSQL ನಂತಹ ವಸ್ತು-ಸಂಬಂಧಿತ DBMS ಗಾಗಿ ಉದ್ದೇಶಿಸಲಾಗಿದೆ.\nMySQL ಅಥವಾ MariaDB ಗಾಗಿ ಬಳಸಿದರೆ, JSON ಪ್ರಕಾರವು ಸಂಬಂಧಿತ json ಮಾನ್ಯತೆ ಪರಿಶೀಲನೆಯೊಂದಿಗೆ ತಯಾರಿಸಲಾಗುತ್ತದೆ.\nSQLite ಗಾಗಿ ಬಳಸಿದರೆ, ಇದು BLOB ಗೆ ಅನುವಾದಿಸಲಾಗುತ್ತದೆ.\nMSSQL ಗಾಗಿ ಬಳಸಿದರೆ, ಮೊದಲ ಕ್ಷೇತ್ರಕ್ಕೆ ಪ್ರಕಾರ ಅಲಿಯಾಸ್ ತಯಾರಿಸಲಾಗುತ್ತದೆ.",
    table_deleted: "ಕೋಷ್ಟಕ ಅಳಿಸಲಾಗಿದೆ",
    area_deleted: "ಪ್ರದೇಶ ಅಳಿಸಲಾಗಿದೆ",
    note_deleted: "ಟಿಪ್ಪಣಿ ಅಳಿಸಲಾಗಿದೆ",
    relationship_deleted: "ಸಂಬಂಧ ಅಳಿಸಲಾಗಿದೆ",
    type_deleted: "ಪ್ರಕಾರ ಅಳಿಸಲಾಗಿದೆ",
    cannot_connect: "ಸಂಪರ್ಕಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ, ಕಂಬಿಗಳು ವಿಭಿನ್ನ ಪ್ರಕಾರಗಳಿವೆ",
    copied_to_clipboard: "ಕ್ಲಿಪ್‌ಬೋರ್ಡ್‌ಗೆ ನಕಲಿಸಲಾಗಿದೆ",
    create_new_diagram: "ಹೊಸ ಚಿತ್ರವನ್ನು ರಚಿಸಿ",
    cancel: "ರದ್ದುಮಾಡಿ",
    open_diagram: "ಚಿತ್ರವನ್ನು ತೆರೆಯಿರಿ",
    rename_diagram: "ಚಿತ್ರವನ್ನು ಮರುಹೆಸರಿಸಿ",
    export: "ರಫ್ತು",
    export_image: "ಚಿತ್ರವನ್ನು ರಫ್ತು ಮಾಡಿ",
    create: "ರಚಿಸಿ",
    confirm: "ದೃಢೀಕರಿಸಿ",
    last_modified: "ಕೊನೆಯದಾಗಿ ಬದಲಾಯಿಸಲಾಗಿದೆ",
    drag_and_drop_files: "ಫೈಲ್ ಅನ್ನು ಇಲ್ಲಿ ಎಳೆಯಿರಿ ಅಥವಾ ಅಪ್‌ಲೋಡ್ ಮಾಡಲು ಕ್ಲಿಕ್ ಮಾಡಿ.",
    support_json_and_ddb: "JSON ಮತ್ತು DDB ಫೈಲ್‌ಗಳನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ",
    upload_sql_to_generate_diagrams:
      "ನಿಮ್ಮ ಕೋಷ್ಟಕಗಳು ಮತ್ತು ಕಂಬಿಗಳನ್ನು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ತಯಾರಿಸಲು sql ಫೈಲ್ ಅನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ.",
    overwrite_existing_diagram: "ಅಸ್ತಿತ್ವದಲ್ಲಿರುವ ಚಿತ್ರವನ್ನು ಮರುಬರೆಯಿರಿ",
    only_mysql_supported:
      "*ಈಗಾಗಲೇ MySQL ಸ್ಕ್ರಿಪ್ಟ್‌ಗಳನ್ನು ಮಾತ್ರ ಲೋಡ್ ಮಾಡುವುದು ಬೆಂಬಲಿತವಾಗಿದೆ.",
    blank: "ಖಾಲಿ",
    filename: "ಫೈಲ್ ಹೆಸರು",
    table_w_no_name: "ಹೆಸರಿಲ್ಲದ ಕೋಷ್ಟಕವನ್ನು ಘೋಷಿಸಲಾಗಿದೆ",
    duplicate_table_by_name: "ಹೆಸರಿನ ಮೂಲಕ ನಕಲು ಕೋಷ್ಟಕ '{{tableName}}'",
    empty_field_name: "ಕೋಷ್ಟಕ '{{tableName}}' ನಲ್ಲಿ ಖಾಲಿ ಕ್ಷೇತ್ರ `ಹೆಸರು`",
    empty_field_type: "ಕೋಷ್ಟಕ '{{tableName}}' ನಲ್ಲಿ ಖಾಲಿ ಕ್ಷೇತ್ರ `ಪ್ರಕಾರ`",
    no_values_for_field:
      "'{{fieldName}}' ಕ್ಷೇತ್ರವು ಕೋಷ್ಟಕ '{{tableName}}' ನಲ್ಲಿ `{{type}}` ಪ್ರಕಾರವಾಗಿದೆ ಆದರೆ ಯಾವುದೇ ಮೌಲ್ಯಗಳನ್ನು ನಿರ್ದಿಷ್ಟಪಡಿಸಲಾಗಿಲ್ಲ",
    default_doesnt_match_type:
      "ಕೋಷ್ಟಕ '{{tableName}}' ನಲ್ಲಿ '{{fieldName}}' ಕ್ಷೇತ್ರದ ಪೂರ್ವನಿಯೋಜಿತ ಮೌಲ್ಯವು ಅದರ ಪ್ರಕಾರಕ್ಕೆ ಹೊಂದಿಕೆಯಾಗುವುದಿಲ್ಲ",
    not_null_is_null:
      "'{{fieldName}}' ಕ್ಷೇತ್ರವು ಕೋಷ್ಟಕ '{{tableName}}' ನಲ್ಲಿ NOT NULL ಆದರೆ ಪೂರ್ವನಿಯೋಜಿತ NULL ಹೊಂದಿದೆ",
    duplicate_fields:
      "ಕೋಷ್ಟಕ '{{tableName}}' ನಲ್ಲಿ ಹೆಸರಿನ ಮೂಲಕ ನಕಲು ಕೋಷ್ಟಕ ಕ್ಷೇತ್ರಗಳು '{{fieldName}}'",
    duplicate_index:
      "ಕೋಷ್ಟಕ '{{tableName}}' ನಲ್ಲಿ ಹೆಸರಿನ ಮೂಲಕ ನಕಲು ಸೂಚಿ '{{indexName}}'",
    empty_index: "ಕೋಷ್ಟಕ '{{tableName}}' ನಲ್ಲಿ ಸೂಚಿ ಯಾವುದೇ ಕಂಬಿಗಳನ್ನು ಸೂಚಿಸುತ್ತಿಲ್ಲ",
    no_primary_key: "ಕೋಷ್ಟಕ '{{tableName}}' ನಲ್ಲಿ ಪ್ರಾಥಮಿಕ ಕೀ ಇಲ್ಲ",
    type_with_no_name: "ಹೆಸರಿಲ್ಲದ ಪ್ರಕಾರವನ್ನು ಘೋಷಿಸಲಾಗಿದೆ",
    duplicate_types: "ಹೆಸರಿನ ಮೂಲಕ ನಕಲು ಪ್ರಕಾರಗಳು '{{typeName}}'",
    type_w_no_fields: "ಕ್ಷೇತ್ರಗಳಿಲ್ಲದ ಖಾಲಿ ಪ್ರಕಾರ '{{typeName}}' ಅನ್ನು ಘೋಷಿಸಲಾಗಿದೆ",
    empty_type_field_name: "ಪ್ರಕಾರ '{{typeName}}' ನಲ್ಲಿ ಖಾಲಿ ಕ್ಷೇತ್ರ `ಹೆಸರು`",
    empty_type_field_type: "ಪ್ರಕಾರ '{{typeName}}' ನಲ್ಲಿ ಖಾಲಿ ಕ್ಷೇತ್ರ `ಪ್ರಕಾರ`",
    no_values_for_type_field:
      "'{{fieldName}}' ಕ್ಷೇತ್ರವು '{{typeName}}' ಪ್ರಕಾರದಲ್ಲಿ `{{type}}` ಪ್ರಕಾರವಾಗಿದೆ ಆದರೆ ಯಾವುದೇ ಮೌಲ್ಯಗಳನ್ನು ನಿರ್ದಿಷ್ಟಪಡಿಸಲಾಗಿಲ್ಲ",
    duplicate_type_fields:
      "ಪ್ರಕಾರ '{{typeName}}' ನಲ್ಲಿ ಹೆಸರಿನ ಮೂಲಕ ನಕಲು ಪ್ರಕಾರ ಕ್ಷೇತ್ರಗಳು '{{fieldName}}'",
    duplicate_reference: "ಹೆಸರಿನ ಮೂಲಕ ನಕಲು ಉಲ್ಲೇಖ '{{refName}}'",
    circular_dependency: "ಕೋಷ್ಟಕ '{{refName}}' ಅನ್ನು ಒಳಗೊಂಡ ವೃತ್ತಾಕಾರದ ಅವಲಂಬನೆ",
    timeline: "ಟೈಮ್‌ಲೈನ್",
    priority: "ಆದ್ಯತೆ",
    none: "ಯಾವುದೂ ಇಲ್ಲ",
    low: "ಕಡಿಮೆ",
    medium: "ಮಧ್ಯಮ",
    high: "ಉನ್ನತ",
    sort_by: "ಇದರಿಂದ ವಿಂಗಡಿಸಿ",
    my_order: "ನನ್ನ ಆದೇಶ",
    completed: "ಪೂರ್ಣಗೊಂಡಿದೆ",
    alphabetically: "ಅಕ್ಷರಮಾಲೆಯ ಕ್ರಮದಲ್ಲಿ",
    add_task: "ಕಾರ್ಯವನ್ನು ಸೇರಿಸಿ",
    details: "ವಿವರಗಳು",
    no_tasks: "ನಿಮ್ಮ ಬಳಿ ಇನ್ನೂ ಯಾವುದೇ ಕಾರ್ಯಗಳಿಲ್ಲ.",
    no_activity: "ನಿಮ್ಮ ಬಳಿ ಇನ್ನೂ ಯಾವುದೇ ಚಟುವಟಿಕೆಗಳಿಲ್ಲ.",
    move_element: "{{name}} ಅನ್ನು {{coords}} ಗೆ ಸರಿಸಿ",
    edit_area: "{{extra}} ಪ್ರದೇಶವನ್ನು ಸಂಪಾದಿಸಿ {{areaName}}",
    delete_area: "ಪ್ರದೇಶವನ್ನು ಅಳಿಸಿ {{areaName}}",
    edit_note: "{{extra}} ಟಿಪ್ಪಣಿಯನ್ನು ಸಂಪಾದಿಸಿ {{noteTitle}}",
    delete_note: "ಟಿಪ್ಪಣಿಯನ್ನು ಅಳಿಸಿ {{noteTitle}}",
    edit_table: "{{extra}} ಕೋಷ್ಟಕವನ್ನು ಸಂಪಾದಿಸಿ {{tableName}}",
    delete_table: "ಕೋಷ್ಟಕವನ್ನು ಅಳಿಸಿ {{tableName}}",
    edit_type: "{{extra}} ಪ್ರಕಾರವನ್ನು ಸಂಪಾದಿಸಿ {{typeName}}",
    delete_type: "ಪ್ರಕಾರವನ್ನು ಅಳಿಸಿ {{typeName}}",
    add_relationship: "ಸಂಬಂಧವನ್ನು ಸೇರಿಸಿ",
    edit_relationship: "{{extra}} ಸಂಬಂಧವನ್ನು ಸಂಪಾದಿಸಿ {{refName}}",
    delete_relationship: "ಸಂಬಂಧವನ್ನು ಅಳಿಸಿ {{refName}}",
    not_found: "ಕಂಡುಬಂದಿಲ್ಲ",
    pick_db: "ಡೇಟಾಬೇಸ್ ಆಯ್ಕೆಮಾಡಿ",
    generic: "ಸಾಮಾನ್ಯ",
    generic_description:
      "ಸಾಮಾನ್ಯ ಚಿತ್ರಗಳನ್ನು ಯಾವುದೇ SQL ರುಚಿಗೆ ರಫ್ತು ಮಾಡಬಹುದು ಆದರೆ ಕೆಲವು ಡೇಟಾ ಪ್ರಕಾರಗಳನ್ನು ಮಾತ್ರ ಬೆಂಬಲಿಸುತ್ತದೆ.",
    enums: "ಎನಮ್‌ಗಳು",
    add_enum: "ಎನಮ್ ಅನ್ನು ಸೇರಿಸಿ",
    edit_enum: "{{extra}} ಎನಮ್ ಅನ್ನು ಸಂಪಾದಿಸಿ {{enumName}}",
    delete_enum: "ಎನಮ್ ಅನ್ನು ಅಳಿಸಿ",
    enum_w_no_name: "ಹೆಸರಿಲ್ಲದ ಎನಮ್ ಕಂಡುಬಂದಿದೆ",
    enum_w_no_values: "ಎನಮ್ '{{enumName}}' ನಲ್ಲಿ ಯಾವುದೇ ಮೌಲ್ಯಗಳಿಲ್ಲ",
    duplicate_enums: "ಹೆಸರಿನ ಮೂಲಕ ನಕಲು ಎನಮ್‌ಗಳು '{{enumName}}'",
    no_enums: "ಯಾವುದೇ ಎನಮ್‌ಗಳಿಲ್ಲ",
    no_enums_text: "ಇಲ್ಲಿ ಎನಮ್‌ಗಳನ್ನು ವ್ಯಾಖ್ಯಾನಿಸಿ",
    declare_array: "ಅರೆ ಅನ್ನು ಘೋಷಿಸಿ",
    empty_index_name: "ಕೋಷ್ಟಕ '{{tableName}}' ನಲ್ಲಿ ಹೆಸರಿಲ್ಲದ ಸೂಚಿಯನ್ನು ಘೋಷಿಸಲಾಗಿದೆ",
    didnt_find_diagram: "ಅಯ್ಯೋ! ಚಿತ್ರವನ್ನು ಕಂಡುಹಿಡಿಯಲಿಲ್ಲ.",
    unsigned: "ಅನ್‌ಸೈನ್ ಮಾಡಲಾಗಿದೆ",
    share: "ಹಂಚಿಕೊಳ್ಳಿ",
    copy_link: "ಲಿಂಕ್ ನಕಲಿಸಿ",
    readme: "README",
    failed_to_load: "ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ. ಲಿಂಕ್ ಸರಿಯಾಗಿದೆಯೇ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ.",
    share_info:
      "* ಈ ಲಿಂಕ್ ಅನ್ನು ಹಂಚಿಕೊಳ್ಳುವುದರಿಂದ ಲೈವ್ ರಿಯಲ್-ಟೈಮ್ ಸಹಯೋಗ ಸೆಷನ್ ರಚಿಸಲಾಗುವುದಿಲ್ಲ.",
  },
};

export { ka, kannada };
